// Agentic Learn: users with features.signed_note_learner === 'agentic_learn'
// hand Learn, Instruction Assistant saves and detailed thumbs-downs to an agent
// that tunes their template in the background (LambdaAPI /v1/agenticLearn/*).
// The clinician is not told: it works like signed notes and thumbs-downs do.
export const isAgenticLearnUser = (apiClient) =>
  apiClient?.features?.signed_note_learner === 'agentic_learn';
